// Same typo list as the backend guard, so the person is warned before they even submit.
const DOMAIN_FIXES = {
  "gamil.com": "gmail.com", "gmial.com": "gmail.com", "gmai.com": "gmail.com",
  "gmail.co": "gmail.com", "gmail.con": "gmail.com", "gmaill.com": "gmail.com",
  "gnail.com": "gmail.com", "gmail.cm": "gmail.com", "gmail.om": "gmail.com",
  "yahooo.com": "yahoo.com", "yaho.com": "yahoo.com", "yahoo.con": "yahoo.com",
  "hotmial.com": "hotmail.com", "hotmail.con": "hotmail.com", "hotmai.com": "hotmail.com",
  "outlok.com": "outlook.com", "outlook.con": "outlook.com", "outllook.com": "outlook.com",
  "icloud.con": "icloud.com", "iclould.com": "icloud.com",
  "aol.con": "aol.com", "comcast.ne": "comcast.net",
};
const TLD_FIXES = { ".con": ".com", ".cmo": ".com", ".ocm": ".com", ".comm": ".com", ".xom": ".com", ".nte": ".net", ".ogr": ".org" };
const PLACEHOLDERS = ["example.com", "example.org", "test.com", "email.com", "domain.com"];
const EMAIL_RE = /^[^@\s]+@[^@\s]+\.[A-Za-z]{2,}$/;

/** Returns a warning sentence, or "" when the address looks fine. */
export function emailProblem(email) {
  const address = (email || "").trim().toLowerCase();
  if (!address) return "";
  if (!EMAIL_RE.test(address)) return "That does not look like a complete email address.";
  const [local, domain] = address.split("@");
  if (DOMAIN_FIXES[domain]) {
    return `Did you mean ${local}@${DOMAIN_FIXES[domain]}? Mail to ${domain} will not arrive.`;
  }
  for (const [wrong, right] of Object.entries(TLD_FIXES)) {
    if (domain.endsWith(wrong)) {
      return `Did you mean ${domain.slice(0, -wrong.length)}${right}? Mail to ${domain} will not arrive.`;
    }
  }
  if (PLACEHOLDERS.includes(domain)) {
    return `${domain} is a placeholder domain, so nothing sent there will be delivered.`;
  }
  return "";
}
